import React from 'react'
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderTitle from '../../../components/HeaderTitle';
import BackButton from '../../../components/BackButton';
import { useForm } from 'react-hook-form';

function UpdateCar() {
    let { state } = useLocation();
    const { token } = useSelector((state) => state.auth)

    const updateCarForm = useForm()

    const updateCarSubmit = (data) => {
        console.log("updateCarSubmit", data)
    }

    console.log("state", state)
    return (
        <div className='container-fluid'>
            <HeaderTitle title='Araç Güncelle' description='Araç bilgilerini buradan güncelleyebilirsiniz.' />
            <div className='row'>
                <div className='col-md'>
                    <div className='card'>
                        <div className='card-body'>
                            <BackButton />

                            <form className='my-3' onSubmit={updateCarForm.handleSubmit(updateCarSubmit)}>
                                <div className='mb-3'>
                                    <label htmlFor='trackingId' className='form-label'>Takip Kodu</label>
                                    <input type='text' className='form-control' id='trackingId' {...updateCarForm.register('trackingId')} defaultValue={state?.trackingId} />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='plate' className='form-label'>Plaka</label>
                                    <input type='text' className='form-control' id='plate' {...updateCarForm.register('plate')} defaultValue={state?.plate} />
                                </div>
                                <div>
                                    <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateCar